import Paper from '@mui/material/Paper';
import React from "react";

const EmptyState = (props) => {
		return (
			<Paper style={{padding: props.padding || 20, minHeight: props.minHeight || 250, textAlign: 'center', display: 'flex', alignItems: 'center', borderRadius: 0, boxShadow: 'none', background: 'none' }}>
              {props.children || <h2 style={{width: '100%', color: 'inherit', fontWeight: 'normal'}}>{props.text}</h2>}
			</Paper>
		)
	}
	export default EmptyState;